import { PlayoutStoreV2Type } from '@kaltura-ott/tvpil-shared/lib/stores/category/playout/playout-store.service';

import { playoutStoreDataResolver } from 'utils';

export function isLive() {
  const { type } = playoutStoreDataResolver();
  return type === PlayoutStoreV2Type.LIVE || type === PlayoutStoreV2Type.START_OVER;
}
